module.exports = __webpack_public_path__ + "img/a5.5a4b9acf.svg";